import { useQueryClient, useQuery, useMutation } from '@tanstack/react-query';
import { notification, Row, Col, Button, Input, Form, Select, Radio, RadioChangeEvent } from 'antd';
import React, { useState } from 'react'
import Loader from '../../../components/loader';
import { getLanguages, postArticleCreate } from '../../../services/api';
import { Editor } from '@tinymce/tinymce-react';
import PageTitle from '../../../components/page-title';

const BlogsCreate = () => {

    const queryClient = useQueryClient();
    const [ ntf, contextHolder ] = notification.useNotification();
    const { data: dataLanguages, isLoading: isLoadingLanguages } = useQuery(['languages'], () => getLanguages());
    const { mutate: mutatePostArticleCreate } = useMutation(postArticleCreate);

    const [editorValue, setEditorValue] = useState("");

    const editorInitConfig = {
        height: 300,
        forced_root_block: '',
        plugins: [
            'paste',
            'lists'
        ],
        menubar: 'edit',
        toolbar: 'undo redo | bold italic underline strikethrough | paste pastetext | bullist numlist | removeformat',
        content_style: 'body { font-family: Helvetica,Arial,sans-serif; font-size:16px }'
    }

    const handleSubmit = (values: any) => {
        mutatePostArticleCreate({text: editorValue, title: values.title, text_main: values.text_main, type: 1, language_id: values.language_id }, {
            onSuccess() {
                queryClient.invalidateQueries(['translations']);
                ntf.success({
                    message: `Success`,
                    description: "Created with success!",
                    placement: "bottomLeft",
                });
            },
            onError() {
                ntf.error({
                    message: `Error`,
                    description: "Something gonne wrong!",
                    placement: "bottomLeft",
                });
            },
        })
    }

    if (isLoadingLanguages) {
        return (
            <Row justify="center">
                <Col span={20}>
                    <Row justify="center"><Loader size={50} /></Row>
                </Col>
            </Row>
        )
    }

    const mapLanguages = () => {
        let langs: any = [];
        dataLanguages && dataLanguages.map((lang: any) => {
            langs.push({value: lang.id, label: lang.name})
        })
        return langs;
    }
    
    return (
        <Row justify="center">
            {contextHolder}
            <PageTitle text={`Placeholder Create`} />
            <Col span={20}>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form
                            name="blog_create"
                            style={{ width: "100%"}}
                            layout="vertical"
                            onFinish={handleSubmit}
                        >
                            <Form.Item
                                label="Blog title goes here"
                                name="title"
                            > 
                                <Input placeholder='Kuda idu divlje svinje' />
                            </Form.Item>
                            <Form.Item
                                label="Here you can add short text for the pages where the article short description is showed. Maybe put one sentence."
                                name="text_main"
                            > 
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="You must assign a language to this placeholder. Otherwise it will not be displayed on the website."
                                name="language_id"
                                initialValue={3}
                            > 
                                <Select
                                    placeholder="Select language of placeholder"
                                    allowClear
                                    defaultValue={3}
                                    options={mapLanguages()}
                                />
                            </Form.Item>
                            <Form.Item
                                label="Content value (can be url, html, plain text)"
                            >   
                                <Editor
                                    apiKey='l1bfxq2606zcs9deej0javlspqpdff9g2nlf21ik18hdmdmm'
                                    onInit={() => {
                                        setEditorValue("")
                                    }}
                                    onChange={(content: any) => setEditorValue(content.level.content)}
                                    initialValue={""}
                                    init={editorInitConfig}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="login-form-button">Save</Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </Col>
        </Row>
      )
}

export default BlogsCreate